import { UAParser } from 'ua-parser-js';
import { getTaiwanLogDateTime } from '@common/commonFunctions';
import apiClientHelper from "../helpers/apiClientHelper";
import Constants from "./constants";

const storeErrorLog = async (error: any, userId?: number) => {
    const { formattedDate, timestamp, timeSlot } = getTaiwanLogDateTime();

    const fileName = `${formattedDate}/${timeSlot}.json`;

    const parser = new UAParser(window.navigator.userAgent)

    const OS = parser.getOS()
    const browser = parser.getBrowser()
    const device = parser.getDevice()

    console.info('fileName:', fileName)

    try {
        let response = await apiClientHelper.callGet(
            `${Constants.GET_PRE_SIGNED_URL}?filePath=${encodeURIComponent(fileName)}&s3BucketName=tw-loyalty-crm-uat-fe-logs`
        );

        let existingData = [];
        let uploadUrl, logData;

        if (response.status === 200) {
            let downloadUrl = response.data.downloadUrl;
            uploadUrl = response.data.uploadUrl;

            try {
                const fetchResponse = await fetch(downloadUrl);
                if (fetchResponse.ok) {
                    existingData = await fetchResponse.json();
                    console.info(existingData, "Existing data fetched");
                } else {
                    console.error("Failed to fetch existing data. Proceeding with empty data.");
                }
            } catch (error) {
                console.error("Error fetching existing data:", error);
            }
        } else {
            console.error("Failed to get presigned URLs:", response.statusText);
        }

        const url = new URL(window.location.href);
        const urlWithoutQueryParams = url.origin + url.pathname;

        logData = {
            error: error?.message || '',
            stack: error?.stack || "",
            url: urlWithoutQueryParams,
            OS: OS?.name || '',
            OSVersion: OS?.version || '',
            device: device?.type || '',
            browser: browser?.name || '',
            memberID: userId ?? "",
            time: timestamp
        };

        existingData = [...existingData, logData];

        try {
            const uploadResponse = await fetch(uploadUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(existingData),
            });

            if (!uploadResponse.ok) {
                throw new Error(`Failed to upload data: ${uploadResponse.statusText}`);
            }

        } catch (uploadError) {
            console.error("Error uploading data:", uploadError);
        }
    } catch (err) {
        console.error("Error retriving data:", err);
    }

};


export default storeErrorLog